/**
 * Created by bartdecorte on 05/05/16.
 */
import Mousetrap from 'mousetrap';

class PlacePicker {
  constructor(params) {
    this.defaultLatLng = { lat: 51.032457, lng: 3.733822 };

    // parameters
    this.params = {
      latLng: undefined,
      $coordinatesInput: undefined,
      $searchInput: undefined,
      autoSearch: undefined,
      $map: undefined,
      map: undefined,
      icon: undefined,
      marker: undefined,
    };

    this.$ROOT = params.$root;
    this.params.$coordinatesInput = this.$ROOT
      .find('.js-coordinates-input')
      .first();
    this.params.$searchInput = $(this.params.$coordinatesInput.data('search'));
    this.params.$map = $(this.params.$coordinatesInput.data('map'));
    this.params.latLng = this.defaultLatLng;
    if (
      typeof this.params.$coordinatesInput.data('latitude') !==
        typeof undefined &&
      typeof this.params.$coordinatesInput.data('longitude') !==
        typeof undefined
    ) {
      this.params.latLng = {
        lat: parseFloat(this.params.$coordinatesInput.data('latitude')),
        lng: parseFloat(this.params.$coordinatesInput.data('longitude')),
      };
    }

    this.createIcon();
    this.initializeMap();
    this.initializeMarker();
    this.initializeSearch();
    this.bindListeners();
  }

  bindListeners() {
    this.params.$coordinatesInput.change((ev) => {
      this.lCoordinatesInputChanged(ev);
    });
    Mousetrap(this.params.$searchInput.get(0)).bind(
      ['return', 'enter'],
      (ev) => {
        ev.preventDefault();
        return false;
      }
    );
  }

  lMarkerDragEnd() {
    return () => {
      this.updateCoordinates(
        this.params.marker.position.lat(),
        this.params.marker.position.lng()
      );
    };
  }

  lAutocompleteChanged() {
    let place = this.params.autoSearch.getPlace();
    if (typeof place !== typeof undefined) {
      if (place.geometry && place.geometry.location) {
        this.updateCoordinates(
          place.geometry.location.lat(),
          place.geometry.location.lng()
        );
        this.params.$searchInput.val('');
      }
    }
  }

  lCoordinatesInputChanged(ev) {
    let exploded = this.params.$coordinatesInput.val().split(',');
    if (exploded.length < 2) {
      this.params.$coordinatesInput.val(
        this.params.latLng.lat + ', ' + this.params.latLng.lng
      );
      return false;
    }

    let lat = parseFloat(exploded[0].trim());
    let lng = parseFloat(exploded[1].trim());

    if (lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
      this.updateCoordinates(lat, lng);
    } else {
      this.params.$coordinatesInput.val(
        this.params.latLng.lat + ',' + this.params.latLng.lng
      );
    }
  }

  createIcon() {
    this.params.icon = {
      scaledSize: { width: 24, height: 35 },
      size: { width: 48, height: 70 },
      anchor: { x: 12, y: 35 },
      url: esign.info.baseUrl + '/images/marker.png',
    };
  }

  initializeMap() {
    this.params.map = new google.maps.Map(this.params.$map.get(0), {
      center: this.params.latLng,
      zoom: 9,
      styles: [
        {
          featureType: 'landscape.man_made',
          elementType: 'geometry',
          stylers: [
            {
              color: '#f7f1df',
            },
          ],
        },
        {
          featureType: 'landscape.natural',
          elementType: 'geometry',
          stylers: [
            {
              color: '#d0e3b4',
            },
          ],
        },
        {
          featureType: 'landscape.natural.terrain',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi.business',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi.medical',
          elementType: 'geometry',
          stylers: [
            {
              color: '#fbd3da',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#bde6ab',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry.stroke',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#ffe15f',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#efd151',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: 'black',
            },
          ],
        },
        {
          featureType: 'transit.station.airport',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#cfb2db',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#a2daf2',
            },
          ],
        },
      ],
      mapTypeControl: false,
      streetViewControl: false,
      zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_TOP },
      scrollwheel: false,
    });
  }

  initializeMarker() {
    this.params.marker = new google.maps.Marker({
      icon: this.params.icon,
      position: this.params.latLng,
      draggable: typeof this.params.$map.data('disabled') === typeof undefined,
    });

    this.params.marker.addListener('dragend', this.lMarkerDragEnd());
    this.params.marker.setMap(this.params.map);
  }

  initializeSearch() {
    this.params.autoSearch = new google.maps.places.Autocomplete(
      this.params.$searchInput.get(0)
    );
    this.params.autoSearch.addListener('place_changed', () => {
      this.lAutocompleteChanged();
    });
  }

  updateCoordinates(lat, lng) {
    this.params.latLng = { lat: lat, lng: lng };
    this.params.marker.setPosition(this.params.latLng);
    this.params.$coordinatesInput.val(lat.toFixed(6) + ', ' + lng.toFixed(6));
    this.params.map.panTo({ lat: lat, lng: lng });
  }
}

export default PlacePicker;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/PlacePicker.js